import { useEffect } from 'react'

import { useNavigate } from 'react-router-dom'

import { useAppSelector } from 'src/Hooks/redux'
import { getUser } from 'src/Redux/auth-process/userSlice/selectors'
import { getUserRole } from 'src/Redux/auth-process/credentialsSlice/selectors'
import { Roles } from 'src/Constants/enums'
import { createdFirst, feedback } from 'src/Router/routes'
import {
  clearPendingGoogleSignupSurvey,
  hasPendingGoogleSignupSurvey,
} from 'src/Utils/pendingGoogleSignupSurvey'

import { isNewAccount } from './useGoogleSignupEvent'

export const useGoogleSignupSurveyRedirect = (): null => {
  const navigate = useNavigate()
  const { id, createdAt } = useAppSelector(getUser)
  const role = useAppSelector(getUserRole)

  useEffect(() => {
    if (!id || !createdAt || !hasPendingGoogleSignupSurvey()) {
      return
    }

    clearPendingGoogleSignupSurvey()

    if (!isNewAccount(createdAt) || role !== Roles.artist) {
      return
    }

    navigate(`${createdFirst}${feedback}`)
  }, [id, createdAt, role, navigate])

  return null
}
